import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, Search, Menu, X } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_940e8ae3-c19e-4add-8a26-04b3a3541f3d/artifacts/59pes23f_logocafe.png";

export default function Navbar({ onToggleSidebar, sidebarOpen }) {
  const { itemCount } = useCart();
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/productos?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchOpen(false);
      setSearchQuery('');
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-[#98d2b2] border-b border-[#8fc8a7]" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14">
          {/* Left menu toggle + Logo */}
          <div className="flex items-center gap-3">
            <button
              data-testid="mobile-menu-toggle"
              className="p-2 text-[#46371c]"
              onClick={() => {
                if (onToggleSidebar) onToggleSidebar();
              }}
            >
              {sidebarOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
            <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
              <img src={LOGO_URL} alt="Keiks Reposteria" className="h-9 w-auto" />
            </Link>
          </div>

          {/* Spacer */}
          <div className="flex-1" />

          {/* Right Shopping Cart */}
          <div className="flex items-center gap-2">
            <Link to="/carrito" className="relative p-2 text-[#46371c] hover:text-[#2d2312] transition-colors" data-testid="cart-link">
              <ShoppingCart className="w-6 h-6" />
              {itemCount >= 0 && (
                <span className="absolute top-0.5 right-0.5 bg-[#e05275] text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full leading-none">
                  {itemCount}
                </span>
              )}
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
